import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiClipboard,
  FiFileText,
  FiGlobe,
  FiPackage,
  FiSearch,
  FiShield,
  FiTruck,
} from "react-icons/fi";

import PageHero from "../../components/PageHero/PageHero";
import Reveal from "../../components/Reveal/Reveal";
import SEO from "../../components/SEO/SEO";
import { services, workflowSteps } from "../../data/siteContent";

const serviceIcons = [
  FiGlobe,
  FiPackage,
  FiFileText,
  FiTruck,
  FiShield,
  FiSearch,
  FiClipboard,
];

export default function Services() {
  return (
    <>
      <SEO
        title="Services"
        description="Review the export services offered by Thamizhi International Ventures, from sourcing and documentation to packaging support and dispatch coordination."
        path="/services"
      />

      <PageHero
        eyebrow="Services"
        title="Services"
        description="Our service stack is designed to help international buyers move from inquiry to dispatch with better visibility, clearer documentation, and a stronger sourcing experience."
        actions={[
          { label: "View products", to: "/products", variant: "primary" },
          { label: "Contact our team", to: "/contact", variant: "secondary" },
        ]}
        stats={[
          { label: "Service areas", value: `${services.length} focused capabilities` },
          { label: "Support style", value: "Responsive and documentation-aware" },
          { label: "Best fit", value: "Importers, distributors, and hospitality buyers" },
        ]}
        media={
          <div className="process-preview">
            {workflowSteps.map((step, index) => (
              <article key={step.title} className="process-preview__item">
                <span>{`0${index + 1}`}</span>
                <div>
                  <strong>{step.title}</strong>
                  <p>{step.description}</p>
                </div>
              </article>
            ))}
          </div>
        }
      />

      <section className="section-band">
        <div className="section-shell">
          <Reveal>
            <div className="section-heading">
              <p className="section-kicker">Service coverage</p>
              <h2 className="section-title">Practical support where buyers usually need the most clarity</h2>
            </div>
          </Reveal>

          <div className="feature-grid">
            {services.map((service, index) => {
              const Icon = serviceIcons[index];

              return (
                <Reveal key={service.title} className="feature-card" delay={index * 70}>
                  <div className="feature-card__icon">
                    <Icon aria-hidden="true" />
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-band section-band--muted">
        <div className="section-shell">
          <Reveal>
            <div className="section-heading">
              <p className="section-kicker">Workflow</p>
              <h2 className="section-title">How we guide the engagement from inquiry to dispatch</h2>
            </div>
          </Reveal>

          <div className="workflow-grid">
            {workflowSteps.map((step, index) => (
              <Reveal key={step.title} className="workflow-card" delay={index * 80}>
                <span>{`0${index + 1}`}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-band section-band--accent">
        <div className="section-shell cta-band">
          <Reveal>
            <p className="section-kicker">Next step</p>
            <h2 className="section-title">Need a sourcing plan, shipping discussion, or buyer-ready product shortlist?</h2>
            <p className="section-copy">
              We can help frame the commercial path before you move into the next shipment.
            </p>
          </Reveal>

          <Reveal className="cta-band__actions" delay={120}>
            <Link to="/contact" className="button button-primary">
              Start the conversation
              <FiArrowRight aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
